import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';

export const ContactInfoWrapper = styled(Flex)`
  margin-bottom: ${({ theme }) => theme.space[6]};
  ${({ theme }) => css`
    @media (max-width: ${theme.components.footer.breakpoint}) {
      margin-bottom: 0;
      margin-top: ${theme.space.s200};
    }
  `}
`;

export const PointerWrapper = styled(Box)`
  cursor: pointer;
`;
